/**
 * TGH Header
 *
 * - Mobile menu toggle ("Menu" / "Close")
 * - Submenu arrow buttons for parent menu items
 * - Scrolled state (Figma: "header fixed")
 */
(function () {
    "use strict";

    var header = document.querySelector(".js-tgh-header");

    if (!header) {
        return;
    }

    var root = document.documentElement;
    var toggle = header.querySelector(".js-tgh-menu-toggle");
    var topBar = header.querySelector(".tgh-header__top-bar");
    var mobileQuery = window.matchMedia("(max-width: 1199px)");

    function setMenuOpen(isOpen) {
        header.classList.toggle("is-menu-open", isOpen);
        root.classList.toggle("tgh-menu-open", isOpen);

        if (toggle) {
            toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }
    }

    if (toggle) {
        toggle.addEventListener("click", function () {
            setMenuOpen(!header.classList.contains("is-menu-open"));
        });
    }

    document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && header.classList.contains("is-menu-open")) {
            setMenuOpen(false);
            toggle.focus();
        }
    });

    // Close overlay menu when switching to desktop layout
    var onBreakpointChange = function (e) {
        if (!e.matches) {
            setMenuOpen(false);
        }
    };

    if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener("change", onBreakpointChange);
    } else {
        mobileQuery.addListener(onBreakpointChange);
    }

    // Submenu toggles
    var parents = header.querySelectorAll(".tgh-header__menu .menu-item-has-children");

    Array.prototype.forEach.call(parents, function (item) {
        var link = item.querySelector("a");
        var button = document.createElement("button");

        button.type = "button";
        button.className = "tgh-header__submenu-toggle";
        button.setAttribute("aria-expanded", "false");
        button.setAttribute("aria-label", (link ? link.textContent.trim() + " " : "") + "submenu");

        button.addEventListener("click", function () {
            var isOpen = item.classList.toggle("is-submenu-open");
            button.setAttribute("aria-expanded", isOpen ? "true" : "false");
        });

        if (link) {
            link.insertAdjacentElement("afterend", button);
        } else {
            item.appendChild(button);
        }
    });

    // Scrolled state
    var ticking = false;

    function updateScrolled() {
        var threshold = topBar ? topBar.offsetHeight : 0;
        header.classList.toggle("is-scrolled", window.pageYOffset > threshold);
        ticking = false;
    }

    window.addEventListener("scroll", function () {
        if (!ticking) {
            window.requestAnimationFrame(updateScrolled);
            ticking = true;
        }
    }, { passive: true });

    updateScrolled();
})();



// WEBPACK FOOTER //
// ./assets/js/modules/tgh-header.js